import { themeColors } from "@/utils/themeColors";
import Tabs, { TabsProps, TabOption } from "../Tabs";

const TabsAlternate = <T extends TabOption>({ tabSx, tabsSx, ...tabProps }: TabsProps<T>) => {
    return (
        <Tabs
            tabsSx={{
                backgroundColor: themeColors.neutral1,
                // modify the selected tab color
                "& .Mui-selected": { color: themeColors.neutralBlack },
                // modify the selected tab pill indicator bg color
                "& .MuiTabs-indicator": { backgroundColor: themeColors.neutralWhite },
                ...tabsSx,
            }}
            tabSx={{
                // modify the hovered tab bg color
                ":not(.Mui-selected):hover": {
                    backgroundColor: themeColors.neutral2,
                },
                ...tabSx,
            }}
            {...tabProps}
        />
    );
};

export default TabsAlternate;
